import { TextField } from '@mui/material';
import type { SxProps, Theme } from '@mui/material';

interface NumberFieldProps {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  step?: number;
  disabled?: boolean;
  sx?: SxProps<Theme>;
  ['aria-label']?: string;
}

/** Compact numeric input used across the config panel. */
export const NumberField = ({
  value,
  onChange,
  min,
  max,
  step,
  disabled,
  sx,
  ...rest
}: NumberFieldProps) => (
  <TextField
    type="number"
    size="small"
    fullWidth
    disabled={disabled}
    value={Number.isFinite(value) ? value : ''}
    onChange={(e) => onChange(parseInt(e.target.value, 10))}
    inputProps={{ min, max, step, 'aria-label': rest['aria-label'] }}
    sx={{
      '& .MuiOutlinedInput-input': { py: 0.75, fontSize: 13 },
      ...sx,
    }}
  />
);
